'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import PropTypes from 'prop-types';
import Rating from 'ecosystem-marketplace-core/components/reviews/Rating';
import { STAR_RATING_EMPTY_STATE } from 'ecosystem-marketplace-core/constants/reviews/RatingTypes';
import WriteReviewButton from './WriteReviewButton';
import ThemeReviewability from '../../records/ThemeReviewability';
const textPath = 'marketplace-assets-ui.themes.details.reviews';

const ReviewsListEmptyState = ({
  isPreview,
  reviewability,
  onWriteReviewClick
}) => {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${textPath}.emptyStateHeading`
      })
    }), /*#__PURE__*/_jsx(Rating, {
      type: STAR_RATING_EMPTY_STATE,
      rating: 0,
      labelSize: "large",
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${textPath}.reviewCount`,
        options: {
          count: 0
        }
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "m-top-8",
      children: /*#__PURE__*/_jsx(WriteReviewButton, {
        disabled: isPreview,
        onClick: onWriteReviewClick,
        reviewability: reviewability,
        size: "md"
      })
    })]
  });
};

ReviewsListEmptyState.propTypes = {
  isPreview: PropTypes.bool.isRequired,
  onWriteReviewClick: PropTypes.func.isRequired,
  reviewability: PropTypes.instanceOf(ThemeReviewability).isRequired
};
ReviewsListEmptyState.defaultProps = {
  isPreview: false
};
export default ReviewsListEmptyState;